import { render, staticRenderFns } from "./leixing.vue?vue&type=template&id=7f6c28f9&scoped=true"
import script from "./leixing.vue?vue&type=script&lang=js"
export * from "./leixing.vue?vue&type=script&lang=js"
import style0 from "./leixing.vue?vue&type=style&index=0&id=7f6c28f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6c28f9",
  null
  
)

export default component.exports